import { getFile } from '@si/utils';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

interface DownloadParams {
  projectId: string;
  reportId: number;
}

export function useDownloadReport() {
  const { mutate, error, isPending, isSuccess, reset } = useMutation<void, Error, DownloadParams>({
    mutationFn: ({ projectId, reportId }: DownloadParams) =>
      getFile({
        url: `/projects/${projectId}/reports/${reportId}/download`,
      }),
  });

  const downloadReport = useCallback((params: DownloadParams) => mutate(params), [mutate]);

  return {
    downloadReport,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
